import { render, staticRenderFns } from "./AttachmentUnityAvailableCategoriesConfigs.vue?vue&type=template&id=d1227f7a&"
import script from "./AttachmentUnityAvailableCategoriesConfigs.vue?vue&type=script&lang=js&"
export * from "./AttachmentUnityAvailableCategoriesConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports